import React from 'react';
import PropTypes from 'prop-types';
import { useLocalStorage } from 'react-use';

import Snackbar from 'components/consumer/Snackbar';

// This allows a Snackbar with a specified storageKey to be shown once to a
// customer. It will continue to be shown until the customer clicks the close
// button, after which it will be hidden (because we store it in local storage)
const SnackbarShowOnce = ({ children, storageKey }) => {
  const [isOpen, setIsOpen] = useLocalStorage(
    `SnackbarShowOnce-isOpen-${storageKey}`,
    true
  );

  return (
    <Snackbar
      isOpen={isOpen}
      onClose={() => {
        setIsOpen(false);
      }}
    >
      {children}
    </Snackbar>
  );
};

SnackbarShowOnce.propTypes = {
  children: PropTypes.node.isRequired,
  storageKey: PropTypes.string.isRequired,
};

export default SnackbarShowOnce;
